import React from "react";
import { object, number, array, string } from "prop-types";
import { Subheadline } from "@quintype/arrow";

import StoryElements from "../story-elements";
import CardImage from "../../atoms/cardimage";
import AuthorAndTimeStamp from "../story-header/author-and-timestamp";

import "./exclusive.m.css";

const PVExclusiveStoryTemplate = ({ story, index, aspectRatio, imageType }) => {
  return (
    <>
      <div styleName="wrapper">
        <div styleName="header-content">
          <CardImage
            story={story}
            aspectRatio={aspectRatio}
            imageType={imageType}
            widths={[400, 1300]}
            sizes="(max-width: 1024px) 10vw, 100vw"
          />
          <div styleName="headline">{story.headline}</div>
        </div>
        <div styleName="story-content">
          <Subheadline lineClamp={10} story={story} clazzName="sub-headline" />
          <div id="exclusive-author-wrapper" styleName="exl-wrapper">
            <AuthorAndTimeStamp story={story} isPVExclusive={true} />
          </div>
          <div styleName="content">
            <StoryElements story={story} cards={story.cards} index={index} />
          </div>
        </div>
      </div>
    </>
  );
};

PVExclusiveStoryTemplate.propTypes = {
  story: object,
  index: number,
  aspectRatio: array,
  imageType: string
};

PVExclusiveStoryTemplate.defaultProps = {
  aspectRatio: [16, 9],
  imageType: "image16x9"
};

const ExclusiveStory = (props) => {
  return <PVExclusiveStoryTemplate story={props.story} index={props.index} />;
};

ExclusiveStory.propTypes = {
  story: object,
  index: number
};

export default ExclusiveStory;
